import "../../../../design/informationAboutTeacherHub.css";
import Footer from "../Footer";
import {motion} from "framer-motion";
import {FaUsers, FaChalkboardTeacher, FaStar, FaLightbulb, FaRocket} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import {API_URL, PUBLIC_URL} from "../../../../api/API_SERVERS";
import axios from "axios";
import {useEffect, useState} from "react";

export default function InformationAboutTeacherHub() {
    const [activeTeachers, setActiveTeachers] = useState(null);
    const navigate = useNavigate();

    const getActiveTeacherCount = async () => {
        try {
            const result = await axios.get(API_URL + PUBLIC_URL);
            setActiveTeachers(result.data.total);
        } catch (error) {
            setActiveTeachers(0);
        }
    };

    useEffect(() => {
        getActiveTeacherCount();
    }, []);

    return (
        <>
            <section className="teacherHubSection">
                {/* Decorative Elements */}
                <div className="decor-circle circle-1"></div>
                <div className="decor-circle circle-2"></div>

                <div className="teacherHub-container">

                    {/* HERO */}
                    <motion.div
                        className="teacherHub-hero"
                        initial={{opacity: 0, scale: 0.9}}
                        whileInView={{opacity: 1, scale: 1}}
                        transition={{duration: 0.6}}
                    >
                        <span className="hubBadge">მასწავლებლის სივრცე 👩‍🏫</span>
                        <h1>გახდი ხილული და <br/> გაუზიარე ცოდნა სხვებს</h1>
                        <p>
                            ვირტუალური ხიდი მშობლებსა და მასწავლებლებს შორის.
                            ჩვენთან ნდობა და ხარისხი მთავარი პრიორიტეტია.
                        </p>
                    </motion.div>

                    {/* STATS */}
                    <div className="teacherHub-stats">
                        <motion.div whileHover={{y: -10}} className="stat-card blue">
                            <div className="icon-box"><FaChalkboardTeacher/></div>
                            <span>{activeTeachers || 0}+</span>
                            <p>აქტიური მასწავლებელი</p>
                        </motion.div>
                        <motion.div whileHover={{y: -10}} className="stat-card orange">
                            <div className="icon-box"><FaUsers/></div>
                            <span>~1 მლნ+</span>
                            <p>პოტენციური მშობელი</p>
                        </motion.div>
                        <motion.div whileHover={{y: -10}} className="stat-card green">
                            <div className="icon-box"><FaStar/></div>
                            <span>4.9 / 5</span>
                            <p>საშუალო რეიტინგი</p>
                        </motion.div>
                    </div>

                    {/* CONTENT CARD */}
                    <motion.div
                        className="info-main-card"
                        initial={{opacity: 0, y: 30}}
                        whileInView={{opacity: 1, y: 0}}
                    >
                        <div className="info-grid">
                            <div className="info-box-styled problems">
                                <h3><FaLightbulb/> პრობლემები, რომლებსაც ვჭრით</h3>
                                <ul>
                                    <li>მოსწავლეების მოძიების სირთულე</li>
                                    <li>დაბალი ხილვადობა ინტერნეტში</li>
                                    <li>არასტაბილური გრაფიკი</li>
                                    <li>ნდობის ფაქტორი</li>
                                </ul>
                            </div>

                            <div className="info-box-styled solutions">
                                <h3><FaRocket/> როგორ გიპოვიან მშობლები</h3>
                                <ul>
                                    <li>✨ საგნის მიხედვით</li>
                                    <li>📍 მდებარეობით და რადიუსით</li>
                                    <li>💰 ხელმისაწვდომი ფასით</li>
                                    <li>⭐ რეალური შეფასებებით</li>
                                </ul>
                            </div>
                        </div>

                        <div className="info-highlight-banner">
                            <p>თქვენი პროფესიონალიზმი იმსახურებს საუკეთესო პლატფორმას! ✨</p>
                        </div>

                        <div className="hub-cta-area">
                            <button className="main-cta-btn" onClick={() => navigate('/register')}>
                                დაიწყე ახლა და გახდი პოპულარული
                            </button>
                        </div>
                    </motion.div>

                </div>
            </section>
            <Footer/>
        </>
    );
}